import { Box } from '@mui/material';
import { CkeditorContentSkeleton } from '../../../../../components/ckeditor-content/CkeditorContentSkeleton';
import { ProviderInfoSkeleton } from '../../../../../components/provider-info/ProviderInfoSkeleton';

export const InstituteDetailPageSkeleton: React.FC = () => {
  return (
    <Box className="container-fluid" sx={{ py: 7.5 }}>
      <ProviderInfoSkeleton type="info" />
      <Box sx={{ mt: 7.5 }}>
        <CkeditorContentSkeleton />
      </Box>
    </Box>
  );
};
